<template>
  <div>
    <div class="table-container" v-if="canVerb(resource, 'index')">
      <actions-toolbar>
        <template #filters>
          <div class="status-filter">
            <div class="pill-wrapper my-3">
              <span
                class="pill"
                v-for="(value, name, index) in activeFilters"
                :key="index"
                data-color="white"
              >
                <span v-b-toggle.sidebar-1 :data-filter="name"
                  ><strong>{{ sidebarFilterName(name, context) }}</strong
                  >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
                >
                <span tabindex="0">
                  <span
                    @click="resetSingleSidebarFilter(name)"
                    title="Rimuovi filtro"
                    >×</span
                  >
                </span>
              </span>
              <template v-if="countActiveFilters">
                <span
                  class="pill"
                  data-color="alert"
                  @click="resetAllFilters()"
                  title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
                >
                  <span
                    ><strong>Reset ({{ countActiveFilters }})</strong></span
                  >
                  <span><span>×</span></span>
                </span>
              </template>
            </div>
          </div>
        </template>
        <b-button-group
          v-b-toggle.sidebar-1
          :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
            countActiveFilters ? ' active' : ''
          }`"
          :title="getDefaultFilterMessage()"
        >
          <base-icon name="filters" width="23" height="23" />
          <span style="font-size: 14px; font-weight: 500">{{
            computedFilterTitle
          }}</span>
        </b-button-group>
      </actions-toolbar>
      <div class="table-container">
        <b-sidebar
          id="sidebar-1"
          :title="computedFilterTitle"
          :backdrop="true"
          width="50dvw"
          shadow
          right
          :visible="open_filter"
          :data-open="open_filter"
          @change="onSidebarFilterChange"
        >
          <b-form @submit.prevent="onSearch()">
            <div class="filter">
              <div class="filter-item">
                <base-select
                  vid="conto"
                  name="conto"
                  label="Conto"
                  v-model="filter.conto"
                  :options="treasuries_opt"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                  @input="onInputTreasury()"
                />
              </div>
              <div class="filter-item">
                <base-datepicker
                  name="cash_time"
                  label="Saldo conto al"
                  v-model="filter.fino_al"
                />
              </div>
            </div>
            <div class="actions-filter-sidebar-wrapper">
              <b-button
                type="submit"
                variant="lisaweb"
                size="sm"
                v-b-toggle:sidebar-1
                >Cerca
              </b-button>
              <b-button
                class="btn--transparent btn-reset"
                type="button"
                size="sm"
                @click="onClearFilter(filterName)"
                >Reset
              </b-button>
            </div>
          </b-form>
        </b-sidebar>
        <b-overlay center :show="isLoading" rounded="sm">
          <!-- Saldo: conto e data a sinistra, importo a destra; il colore
               dell'importo e l'etichetta dicono se è positivo o negativo. -->
          <div class="saldo-card">
            <template v-if="filter.conto && search">
              <div class="saldo-card__info">
                <div class="saldo-card__label">Saldo del conto</div>
                <div class="saldo-card__treasury">{{ treasury }}</div>
                <div class="saldo-card__label">
                  al {{ toLocaleDate(searchedAt) }}
                </div>
              </div>
              <div class="saldo-card__value" :class="`is-${status}`">
                <div class="saldo-card__amount">
                  {{ toLocaleCurrency(data) }}
                </div>
                <span v-if="status !== 'default'" class="saldo-card__status">
                  {{ status === "positive" ? "In positivo" : "In negativo" }}
                </span>
              </div>
            </template>
            <p v-else class="saldo-card__empty">
              Scegli un conto e una data nei filtri per vedere il saldo.
            </p>
          </div>
          <template #overlay>
            <div class="text-center">
              <div class="custom-loader"></div>
              <p class="loading-text">Operazione in corso...</p>
            </div>
          </template>
        </b-overlay>
      </div>
    </div>
    <div v-else class="mt-3">
      <b-icon icon="info-circle" scale="1.00"></b-icon>
      Non hai i permessi
    </div>
  </div>
</template>

<script>
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import { mapGetters } from "vuex";
import BaseIcon from "@/components/BaseIcon";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { toLocaleCurrency } from "@/utils/strings";
import { today, toLocaleDate } from "@/utils/dates";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";

export default {
  mixins: [CustomFiltersMixin, SidebarFilterMixin],
  data() {
    return {
      repository: "cash_entry",
      resource: "movimenti_prima_nota",
      context: "bank_statement",
      treasuries_opt: [],
      data: 0,
      isLoading: false,
      performedSearch: false,
      activeFilters: {},
      search: false,
      status: "default",
      filter: this.initFilter(),
      treasury: null,
      searchedAt: null,
    };
  },
  components: {
    BaseDatepicker,
    BaseIcon,
    BaseSelect,
  },
  computed: {
    computePerformedSearch() {
      return this.performedSearch;
    },
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
  },
  methods: {
    toLocaleCurrency,
    toLocaleDate,
    initFilter() {
      let init = {
        byAttribute: {
          cash_time: null,
        },
        fino_al: today(),
        conto: null,
      };
      return init;
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    onSearch() {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      if (this.filter.fino_al && this.filter.conto) {
        this.isLoading = true;
        const Repo = RepositoryFactory.get(this.repository);
        const queryString = `fino_al=${this.filter.fino_al}&conto=${this.filter.conto}`;
        Repo.summary(queryString)
          .then((response) => {
            this.data = response?.data?.saldo ? response.data.saldo : 0;
            this.setTotalizerStatus();
            this.$showSnackbar({
              preset: "success",
              text: `Calcolo 'Saldo Conto' terminato`,
            });
            // La data mostrata è quella della ricerca, non quella del filtro.
            this.searchedAt = this.filter.fino_al;
            this.search = true;
            this.isLoading = false;
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({
              preset: "error",
              text: `${errMsg}`,
            });
            this.isLoading = false;
          });
      } else {
        this.$showSnackbar({
          preset: "success",
          text: `Devi impostare i campi 'data Al' e 'saldo del conto'`,
        });
      }
    },
    onInputTreasury() {
      this.treasury = !this.filter.conto
        ? null
        : this.treasuries_opt.find(
            (treasury) => treasury.value == this.filter.conto,
          )?.text;
      this.search = false;
    },
    setTotalizerStatus() {
      if (this.data > 0) {
        this.status = "positive";
      } else if (this.data < 0) {
        this.status = "negative";
      } else {
        this.status = "default";
      }
    },
    onClearFilter() {
      this.filter.fino_al = null;
      this.filter.conto = null;
    },
    ...mapGetters("auth", {
      getContiPrimaNota: "allContiPrimaNota",
    }),
  },
  created() {
    this.treasuries_opt = this.getContiPrimaNota().map((el) => {
      return {
        value: el.value,
        text: el.text,
      };
    });
  },
};
</script>

<style lang="scss" scoped>
.saldo-card {
  display: flex;
  align-items: center;
  gap: 24px;
  margin: 8px 16px 0;
  padding: 20px 24px;
  background: white;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
}

.saldo-card__label,
.saldo-card__empty {
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
}

.saldo-card__empty {
  margin: 0;
}

.saldo-card__treasury {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--color-text);
}

.saldo-card__value {
  margin-left: auto;
  text-align: right;
  color: var(--color-text);

  &.is-positive {
    color: var(--color-success);
  }

  &.is-negative {
    color: var(--color-danger-strong);
  }
}

.saldo-card__amount {
  font-size: 32px;
  font-weight: 600;
  line-height: 1.2;
}

.saldo-card__status {
  display: inline-block;
  margin-top: 4px;
  padding: 2px 10px;
  border-radius: var(--radius-pill);
  font-size: var(--font-size-sm);
  background: color-mix(in srgb, currentColor 12%, transparent);
}
</style>
